export default __webpack_public_path__ + "static/media/pattern.8ce9aac0.png";